
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertManagerService } from '@core/services/shared/alert-manager.service';
import { HttpResponse } from '@microsoft/signalr';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SweetalertCustom } from 'src/app/shared/utils/sweetalert-custom';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(
      private alertManager: AlertManagerService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                tap((event: HttpEvent<any>) => {
                    // Reseta o flag somente quando a resposta final de sucesso chegar
                    if (event instanceof HttpResponse) {
                        this.alertManager.resetSuppression();
                    }
                }),
                catchError((httpErrorResponse) => {
                    if (this.alertManager.shouldShowAlert()) {
                        if (httpErrorResponse.error instanceof ErrorEvent) {
                            // Este é um erro do lado do cliente.
                          if (httpErrorResponse.status !== 401) {
                            SweetalertCustom.showAlertConfirm(`Falha na operação.`, { type: 'error' }, 'Ok', 'Contate o administrador do sistema.');
                          }
                        }
                        // Este é um erro do lado do servidor.
                        else if (httpErrorResponse.error?.errors) {
                            SweetalertCustom.showAlertConfirm(httpErrorResponse.error.errors, { type: 'error' });
                        } else {
                            SweetalertCustom.showAlertConfirm(`Falha na operação.`, { type: 'error' });
                        }
                    }
                    return throwError(httpErrorResponse.error);
                })
            );
    }
}
